export default __webpack_public_path__ + "static/media/Rtt.f7264313.png";